import {Injectable} from '@angular/core';
import {UserResponseModel} from '../models/user-response.model';

@Injectable()

export class TokenManager {

  private tokenKey: string = 'app_token';

  private currentUser: string = 'currentUser';
  private user: UserResponseModel = new UserResponseModel();


  private store(content: Object) {
    localStorage.setItem(this.tokenKey, JSON.stringify(content));
  }

  private retrieve() {
    const storedToken: string = localStorage.getItem(this.tokenKey);
    if (!storedToken) { throw new Error('no token found'); }
    return storedToken;
  }

  public retrieveCurrentUser() {

    const storedUser: string = localStorage.getItem(this.currentUser);
    if (!storedUser) { throw new Error('no user found'); }


    try {
      this.user = JSON.parse(storedUser);
    } catch (err) {
      console.error(err);
    }
    return this.user;
  }

  public generateNewToken(userResponseModel: UserResponseModel) {
    const token = userResponseModel;
    const currentTime: number = (new Date()).getTime() + 2 * 60 * 60 * 1000;
    this.store({ttl: currentTime, token});
  }

  public retrieveToken() {

    let currentTime: number = (new Date()).getTime(), token = null;
    try {
      const storedToken = JSON.parse(this.retrieve());
      if (storedToken.ttl < currentTime) {
    //    this.removeToken();
        throw new Error('invalid token found');
        }
      token = storedToken.token;
    } catch (err) {
      console.error(err);
    }
    return token;

  }


  public removeToken() {

    try {
      localStorage.clear();
    //  sessionStorage.removeItem(this.tokenKey);
    } catch (err) {
      console.error(err);
    }


  }
}



// WEBPACK FOOTER //
// ./src/app/services/TokenManager.ts